import { PERMISSIONS } from '../../constants';
import edit from './AppLabelEdit';

export default {
  list: edit,
  name: 'app-labels',
  permissions: [PERMISSIONS.APP_LABEL],
  options: { label: 'Textos do aplicativo' },
};